const BUSY = 'common/pageTranstition/BUSY';
const IDLE = 'common/pageTranstition/IDLE';

const initialState = {
  busy: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case BUSY:
      return {
        busy: true
      };
    case IDLE:
      return {
        busy: false
      };
    default:
      return state;
  }
}

export function setBusy(isBusy) {
  if (isBusy) {
    return {type: BUSY};
  }

  return {type: IDLE};
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/pageTranstition.js